module.exports = __webpack_public_path__ + "files/bc51a67cf834d181c7e8ef13cba93ff6.svg";